export const TOGGLE_COLLAPSED_NAV = 'TOGGLE_COLLAPSED_NAV';
export const TOGGLE_TOP_NAV = 'TOGGLE_TOP_NAV';
